import script from "./UsuarioModificarDatos.vue?vue&type=script&setup=true&lang=js"
export * from "./UsuarioModificarDatos.vue?vue&type=script&setup=true&lang=js"

import "./UsuarioModificarDatos.vue?vue&type=style&index=0&id=19636a19&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19636a19"]])

export default __exports__